const { createElem } = require('./helperFunctions');

// new method of stream sectioning, which doesn't rely on the use of blog tiles
const buildSectionHeaderTiles = (sectionHeaderConfig) => {
    // take the config item passed in, which will be an array of objects, and iterate over them
    sectionHeaderConfig.forEach((item, index) => {
        // build an <li> element for each object
        const sectionHeaderTile = createElem('li', { class: 'tile section-header-tile', id: `id-${index}` });
        // build the text element for each object, getting the text variable from the object (which can be edited from the back of the hub)
        const sectionHeaderText = createElem('h3', { class: 'section-header-text' }, `${item.text}`);
        // append the section header text to the tile element
        sectionHeaderTile.appendChild(sectionHeaderText);

        // select the tile with the ID designated in the config code block at the back of the hub
        const target = document.querySelector(`#collection-items .clearfix li.tile[data-id='${item.target}']`);

        //check if element exist after clicking load more to prevent duplication
        if (!target || document.querySelector(`#id-${index}`)) {
            return;
        }
        // insert the section header directly before that selected tile
        target.insertAdjacentElement('beforebegin', sectionHeaderTile);
    });
};

const initSectionHeaderTiles = () => {
    // return early if the correct obData doesn't exist, or if we're not on a stream level page
    if (!window.obData || !window.obData.sectionHeaderTiles || !document.body.classList.contains('listing-page')) {
        return;
    }

    // assign the stream section config object on the window to a variable
    const sectionHeaderConfig = window.obData.sectionHeaderTiles;
    // get the current stream ID
    const streamId = document.querySelector('#page-type-identifier').dataset.collectionId;
    // create an array of keys from the sectionHeaderConfig object, which represent the IDs of streams that will be sectioned
    const sectionHeaderStreams = Object.keys(sectionHeaderConfig);

    // check if the array of stream IDs includes the ID of the current stream, and if so, run the code
    if (sectionHeaderStreams.includes(streamId)) {
        // call the function to build the section headers, passing in the config object for the current stream
        buildSectionHeaderTiles(sectionHeaderConfig[streamId]);
    }
};



export { initSectionHeaderTiles };


// WEBPACK FOOTER //
// ./scriptPartials/handleSectionHeaderTiles.js